import { baseApi } from 'api/base';
import { fileApi } from 'api/file';
import { BackendFileType } from 'api/file/params';
import { RequestTracingItemAddDTO, RequestTracingItemDTO } from './types';

const addRequestMotion = async (data: RequestTracingItemDTO, entryId: string) => {
  const { registryOperation, file, ...rest } = data;
  const uploadedFile = file
    ? await fileApi.uploadFile(file[0], BackendFileType.REQUEST_DOCUMENT)
    : undefined;
  const res: RequestTracingItemAddDTO = {
    registryOperation: data.registryOperation!,
    registryEntry: {
      id: entryId,
      requestTracingHistoryList: [
        {
          ...rest,
          id: undefined,
          fileList: uploadedFile ? [uploadedFile] : undefined,
        },
      ],
    },
  };
  await baseApi.post('/request/tracing/add', res);
};

const removeRequestMotion = async (id: string) => {
  await baseApi.post('/request/tracing/delete', { id });
};

export const requestMotionApi = {
  addRequestMotion,
  removeRequestMotion,
};
